import { cn } from "design-system/utils"
import {
  getTimeRange,
  resolveTimeDimension,
  TimeDimension,
  TimeFrame,
  TimeFramePreset,
} from "schema"
import { TimeDimensionSelector } from "./TimeDimensionSelector"
import { TimeFrameSelector } from "./TimeFrameSelector"

type Props = {
  value: TimeFrame
  dimension?: TimeDimension
  dimensions?: readonly TimeDimension[]
  presets?: readonly TimeFramePreset[]
  className?: string
  onChange: (value: { timeFrame: TimeFrame; timeDimension: TimeDimension }) => void
}

export function TimeRangeSelector({
  value,
  dimension,
  dimensions,
  presets,
  className,
  onChange,
}: Props) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <TimeFrameSelector
        value={value}
        presets={presets}
        onChange={(timeFrame) =>
          onChange({
            timeFrame,
            timeDimension: resolveTimeDimension(getTimeRange(timeFrame), dimension, dimensions),
          })
        }
      />
      {dimension && (
        <TimeDimensionSelector
          value={dimension}
          range={getTimeRange(value)}
          dimensions={dimensions}
          onChange={(timeDimension) => onChange({ timeFrame: value, timeDimension })}
        />
      )}
    </div>
  )
}
